import { DynamicControl } from './DynamicControl';
import PropTypes from 'prop-types';
import { DynamicFieldData } from './DynamicControlTypes';
import { Grid } from '@mui/material';
import _get from 'lodash/get';
import { Card, CardContent } from '@mui/material';
import CardHeader from '../yachtDashboard/components/CardHeader.component';

export const DashboardDetail = ({
  fields,
  render,
  data,
  colorTab,
  hasHeader,
  departmentColor,
  departmentName,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        mb: 2,
        mt: 1,
        borderRadius: 2,
        transition: 'transform 0.2s, box-shadow 0.2s',
        borderLeft: `15px solid ${colorTab}`,
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        },
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      <CardContent style={{ padding: '5px 10px' }}>
        <Grid container>
          {hasHeader && (
            <Grid
              item
              xs={12}
              sm={4}
              md={0.5}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <CardHeader
                color={departmentColor}
                departmentName={departmentName}
              />
            </Grid>
          )}
          {fields.map(({ xs, sm, md, lg, key, ...d }) => {
            const value = _get(data, key);
            return (
              <Grid
                item
                xs={xs}
                sm={sm}
                md={md}
                lg={lg}
                key={key}
                {...d}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                {render(key, value) || (
                  <DynamicControl {...d} value={value} />
                )}
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

DashboardDetail.propTypes = {
  fields: PropTypes.arrayOf(DynamicFieldData),
};
